const doc = [({"da":({"js":({"models_table":({"add_column_button":({"label":"Etiket", "please_choose_an_attribute":"Vælg venligst en attribut"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;